import {outter_post} from 'common/js/axios-helper';
import {RichApi} from "./constant/UrlMapper";

const host ="8880"
const host1 ="8885"
const host2 ="9000"


const merchantaccessList = (data) => {
    return outter_post(RichApi.MerchantAccessList, data, host1);
};
const merchantaccessUpdateFile = (data) => {
    return outter_post(RichApi.MerchantAccessUpdateFile, data, host1);
};
const merchantaccessSh = (data) => {
    return outter_post(RichApi.MerchantAccessSh, data, host1);
};




export default {
    merchantaccessList,
    merchantaccessUpdateFile,
    merchantaccessSh,
}



// WEBPACK FOOTER //
// ./src/service/RichService.js